(function(){
	'use strict';
	angular.module('app.setup')
		.controller('userAccessHistory', userAccessHistory);

	userAccessHistory.$inject = ['$scope', '$timeout', '$uibModal', '$rootScope', '$location',
		'tableService', 'leanFilterService', 'manageEmailAlertsService', 'tableRenderService', 'siteService'];

	function userAccessHistory($scope, $timeout, $uibModal, $rootScope, $location, 
			tableService, leanFilterService, manageEmailAlertsService, tableRenderService, siteService) {
		var vm = this;
		var rendererParams = {};
		var reportSettingsName = 'UserLogonHistory';
		var reportSettingsId;
		var userNdx = globalConfig.user.id;

		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}

		var extraParams = [{}];
		var noPaging = true;
		
		var defaultFilters = [{}];

		function setUrl() {
			var url = 'User/' + userNdx + '/AccessHistory';
			return url;
		}

		var columns = [{
			'id': 'factoryName',
			'display': 'Site Name',
			'width': 200,
			'sort': false,
			'disabledShowHide': true
		},
		{
			'id': 'daysSinceLastAccessFmt',
			'display': 'Access Date',
			'width': 100,
			'sort': false,
			'disabledShowHide': true
		}];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportUrl: setUrl(),
			noPaging: noPaging,
			columns: columns,
			pinnedColumns: [],
			defaultFilters: defaultFilters,
			defaultSort: 'factoryName',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			hideFiltersContainer: true,
			hideNoResultsSuggestion: true,
			hasTabs: true,
			setColumnDefaults: true,
			noFactory: true,
			footer: false,
			isGlobalReportSetting:true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
	
		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			var url = setUrl();
			params.url = url;
			return tableService.getData(params, extraParams).then(function (response) {
				calculateLastAccess(response[0]);
				return response;
			});
		}

		function calculateLastAccess(response) {
			if (response && response.length) {
				angular.forEach(response, function(row) {
					row.daysSinceLastAccessFmt = '';
					if (row.daysSinceLastAccess === 0) {
						row.daysSinceLastAccessFmt = 'Today';
					} else if (row.daysSinceLastAccess === 1) {
						row.daysSinceLastAccessFmt = 'Yesterday';
					} else {
						row.daysSinceLastAccessFmt = row.daysSinceLastAccess + ' days ago';
					}
				});
			}
		}

		init();

		function init() {
			var incomingQParam = $location.search();
			if (incomingQParam && incomingQParam.userNdx) {
				userNdx = incomingQParam.userNdx;
			}
			vm.hasMultipleCustomers = siteService.getCustomersCount() > 1;
			leanFilterService.clearFilters();
			leanFilterService.setMasterFilterList([]);
		}
	};
})();